import { QueryClient } from '@tanstack/react-query';

/**
 * @constant queryClient
 * @description Configuración del QueryClient de TanStack Query para el manejo del estado del servidor.
 * Incluye configuraciones por defecto para el manejo de errores, reintentos y caché.
 * Este QueryClient es compartido entre el host y los módulos remotos para garantizar
 * un comportamiento consistente y permitir el uso de TanStack Query en módulos federados.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Reintentar automáticamente las consultas fallidas
      retry: 1,
      // Tiempo de refetch en segundo plano (5 minutos)
      refetchOnWindowFocus: true,
      // Mantener los datos en caché por 5 minutos
      staleTime: 5 * 60 * 1000,
      // Mantener los datos en caché sin usar por 10 minutos
      gcTime: 10 * 60 * 1000,
    },
    mutations: {
      // Reintentar automáticamente las mutaciones fallidas
      retry: 1,
    },
  },
});

